import { substringFromTargetText, substringToTargetText } from '../utils';
import { isDate, isValid } from 'date-fns';
import { isBoolean } from 'lodash';
import { dot } from 'dot-object';
import { formatDateToStartOfTheDay } from './date';

export const tableNames = {
  USER: 'Adm_User',
};

export const formFieldTypes = {
  TEXT: 'text',
  STRING: 'STRING',
  LONG_STRING: 'LONG_STRING',
  AUTOCOMPLETE: 'autocomplete',
  COMBO_BOX: 'COMBO_BOX',
  DATE: 'date',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
};

export const fieldsArrayTypes = {
  DATE: 'date',
  OBJECT: 'object',
  ENUM: 'enum',
  TEXT: 'text',
};

export const searchOperators = {
  EQUAL: { value: '=' },
  LIKE: { value: 'LIKE' },
  IN: { value: 'IN' },
  GREATER_THAN: { value: '>' },
  LESS_THAN: { value: '<' },
  GREATER_THAN_OR_EQUAL: { value: '>=' },
  LESS_THAN_OR_EQUAL: { value: '<=' },
  NOT_EQUAL: { value: '!' },
  IS_NULL: { value: 'IsNull' },
  IS_NOT_NULL: { value: 'NotNull' },
};

export const finalizeSearchData = (searchData, activePage, pageSize) => {
  return {
    ...searchData,
    pageNumber: activePage,
    pageSize,
  };
};

export const entryArrayFilterHandler = (
  entryArray,
  fieldsArray,
  isForJoinColumnProp = false
) => {
  return entryArray?.filter(
    (entry) =>
      (entry[1] || isBoolean(entry[1])) &&
      fieldsArray?.find(
        (field) =>
          ((isForJoinColumnProp && field.type === fieldsArrayTypes.OBJECT) ||
            (!isForJoinColumnProp && field.type !== fieldsArrayTypes.OBJECT)) &&
          field.field.includes(entry[0])
      )
  );
};

export const packSearchCriteria = (entry, fieldsArray) => {
  const object = fieldsArray.find((a) => a.field === entry[0]);
  if (object) {
    const operator = object.operator || searchOperators.LIKE.value;
    const objectField = object?.realColName || object.field;
    switch (object.type) {
      case fieldsArrayTypes.DATE:
        return setDateCriteria(
          objectField,
          entry[1],
          operator,
          !!object?.realColName
        );
      case fieldsArrayTypes.OBJECT:
        return setObjectCriteria(objectField, entry[1], operator);
      case fieldsArrayTypes.ENUM:
        return setEnumCriteria(objectField, entry[1], operator);
      default:
        return {
          property: objectField,
          value: entry[1],
          operator,
        };
    }
  } else {
    return {};
  }
};

function setDateCriteria(objectField, value, operator, isRealColName) {
  const dateColumnName = isRealColName
    ? objectField
    : getDateColumnName(objectField);
  return (
    isValid(value) && {
      property: dateColumnName,
      value: formatDateToStartOfTheDay(value),
      operator,
    }
  );
}

function setObjectCriteria(objectField, value, operator) {
  const referenceColumn = substringToTargetText(objectField, '.');
  const referenceProp = substringFromTargetText(objectField, '.');
  return (
    value && {
      joinColumnName: referenceColumn,
      searchFilter: {
        property: referenceProp,
        value,
        operator,
      },
    }
  );
}

function setEnumCriteria(objectField, value, operator) {
  const propertyName = substringToTargetText(objectField, '.');
  return {
    property: propertyName,
    value,
    operator,
  };
}

function getDateColumnName(objectField) {
  let dateColumnName = objectField;
  if (objectField.endsWith('From')) {
    dateColumnName = substringToTargetText(objectField, 'From');
  }
  if (objectField.endsWith('To')) {
    dateColumnName = substringToTargetText(objectField, 'To');
  }
  return dateColumnName;
}

export const setFilterCriteriaForHistory = (entryArray, values) => {
  const dateValues = entryArray.filter((element) => isDate(element[1]));
  let filterCriteria = {};
  dateValues.forEach((element) => {
    filterCriteria = {
      ...filterCriteria,
      [element[0]]: formatDateToStartOfTheDay(element[1]),
    };
  });
  return { ...values, ...filterCriteria };
};

export const setFilterCriteriaForSearch = (values, fields) => {
  if (!values) return null;
  const dotNotationValuesObj = dot.dot(values);
  const entryArray = Object.entries(dotNotationValuesObj);
  const dateValues = entryArray.filter(
    (element) =>
      fields?.find((f) => f.name === element[0])?.type === formFieldTypes.DATE
  );
  let filterCriteria = {};
  dateValues.forEach((element) => {
    filterCriteria = {
      ...filterCriteria,
      [element[0]]: new Date(element[1]),
    };
  });

  return { ...values, ...filterCriteria };
};
